import { useContext } from "react";
import { AuthConfigContext } from "../contexts/AuthConfigContext";
import type { AuthConfig } from "../types";

/**
 * Hook to access the auth configuration provided by AuthConfigProvider.
 * Must be used within an AuthConfigProvider.
 */
export const useAuthConfig = (): AuthConfig => {
  const context = useContext(AuthConfigContext);

  if (!context) {
    throw new Error("useAuthConfig must be used within an AuthConfigProvider");
  }

  return context;
};
